import { AnimatePresence } from "framer-motion";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ContButtons,
  ModalContainerStyleds,
  ProductsCart,
} from "./ModalCartStyle";

import Button from "../../UI/button/Button";
import { clearCart, delFromCart } from "../../../redux/cart/cart-action";
import ProductItem from "./ProductItem";
import Titles from "../../UI/title/Titles";
import useTotal from "../../../hooks/useTotal";
import { auth, handleAddToCart } from "../../../firebase/firebase-utils";

const ModalCart = () => {
  const { hiddenMenu, cart } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const { total } = useTotal();
  const [purchaseSuccess, setPurchaseSuccess] = useState(false); // Estado local para controlar si la compra fue exitosa

  const handleAddToCartClick = async () => {
    try {
      let userId = auth.currentUser.uid;
      if (cart.length > 0) {
        for (const item of cart) {
          await handleAddToCart(userId, item);
        }
        setPurchaseSuccess(true); // Establecer el estado de compra exitosa a true
        dispatch(clearCart()); // Limpiar el carrito después de la compra exitosa
        showPurchaseSuccessMessage(); // Mostrar el mensaje de compra exitosa
      }
    } catch (error) {
      console.log(error);
    }
  };

  const showPurchaseSuccessMessage = () => {
    alert("¡Compra realizada con éxito!"); // Mostrar una alerta con el mensaje de compra exitosa
  };

  return (
    <AnimatePresence>
      {!hiddenMenu && (
        <ModalContainerStyleds
          initial={{ translateX: 600 }}
          animate={{ translateX: 0 }}
          exit={{ translateX: 600 }}
          transition={{ duration: 0.5 }}
          key="cart-user"
        >
          <Titles>
            <span>CART</span>
          </Titles>

          {cart.length > 0 ? (
            <ProductsCart>
              {cart.map((item, index) => (
                <ProductItem
                  key={index}
                  data={item}
                  delOneFromCart={() => dispatch(delFromCart(item.id))}
                  delAllFromCart={() => dispatch(delFromCart(item.id, true))}
                />
              ))}
            </ProductsCart>
          ) : (
            <p>No items in cart</p>
          )}

          <p>Total USD: {total}</p>
          <ContButtons>
            <Button onClick={handleAddToCartClick}>ADD</Button>
            <Button secondary="true" onClick={() => dispatch(clearCart())}>
              DELETE
            </Button>
          </ContButtons>
        </ModalContainerStyleds>
      )}
    </AnimatePresence>
  );
};

export default ModalCart;
